
import { useAdminSync } from '@/hooks/useAdminSync';
import { useToast } from '@/hooks/use-toast';

/**
 * Hook for managing data synchronization in the admin page
 */
export const useAdminPageSync = (
  adminState: any,
  refreshAttendees: () => Promise<any>,
  refreshAdminData: () => Promise<any>,
  resetData: () => Promise<any>,
  recordAction: (actionType: string, adminName: string, details?: string) => void,
  adminName: string,
  usingSupabase: boolean
) => {
  const { toast } = useToast();
  
  const {
    lastSyncTime,
    handleManualSync,
    handleResetData
  } = useAdminSync(
    adminState, 
    refreshAttendees, 
    refreshAdminData, 
    null, // Demo functionality removed
    resetData, 
    recordAction, 
    adminName, 
    { toast },
    usingSupabase,
    true // Always production
  );
  
  return {
    lastSyncTime,
    handleManualSync,
    handleResetData
  };
};
